import { render, staticRenderFns } from "./TwoCreateForm.vue?vue&type=template&id=1bda8f8e"
import script from "./TwoCreateForm.vue?vue&type=script&lang=js"
export * from "./TwoCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports